const integral = {
  state: () => ({
    // 分组标签列表
    positionList: [],
    //类型标签列表
    typeList: [],
    //筛选参数
    paramIntegralData: {},

  }),
  mutations: {
    SET_KVS_STATE (state, payload) {
      const { key, value } = payload
      state[key] = value
    },
  },
  getters: {
    getPositionList (state) {
      return state.positionList
    },
    getTypeList (state) {
      return state.typeList
    },
    getParamIntegralData (state) {
      return state.paramIntegralData
    }


  },
  actions: {

  },
}

export default integral
